import { useState } from 'react'
import { Button, Table } from 'react-bootstrap'
import useMutationDeleteUserLinqProduct from 'hooks/use-mutation-delete-user-product'
import { LinqProduct } from 'interfaces/linq-product'
import { Card } from 'interfaces/card'
import { User } from 'interfaces/user'
import TransferProductToUserModal from 'components/transfer-product-to-user-modal'

const UserActivatedProductsTable = ({
  userLinqProducts,
  allLinqProducts,
  cards,
  userUUID = '',
  user = null,
}: {
  userLinqProducts: LinqProduct[]
  allLinqProducts?: LinqProduct[]
  cards?: Card[]
  userUUID?: string
  user?: User | null
}) => {
  const [transferProduct, setTransferProduct] = useState<LinqProduct | null>(
    null
  )

  const deleteUserLinqProductMutation = useMutationDeleteUserLinqProduct({
    userUUID,
  })

  const handleDeactivateProductClick = (id: number) => {
    if (window.confirm('Are you sure you want to deactivate this product?'))
      deleteUserLinqProductMutation.mutate({ userLinqProductId: id })
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <Table striped bordered hover size="sm" variant="dark">
        <tbody>
          {userLinqProducts?.map((userLinqProduct) => (
            <tr className="pointer" key={userLinqProduct.id}>
              <td style={{ verticalAlign: 'middle' }}>
                <img
                  src={`${
                    allLinqProducts?.find(
                      (lp) => lp.name === userLinqProduct.kind
                    )?.image_path
                  }`}
                  alt={userLinqProduct.nick_name}
                  className="bg-white img-fluid img-thumbnail my-1"
                  style={{ maxWidth: '90px' }}
                />
              </td>
              <td style={{ wordBreak: 'break-word', maxWidth: '500px' }}>
                <h5 className="my-1">{userLinqProduct.nick_name}</h5>
                <p className="mb-1 text-white-50">{userLinqProduct.kind}</p>
                <p
                  className="mb-1 text-white-50"
                  style={{ wordBreak: 'break-all' }}
                >
                  /
                  {
                    cards?.find(
                      (card) => userLinqProduct.alias.aliasable_id === card.id
                    )?.connecting_code
                  }
                </p>
                <p
                  className="mb-1 text-white-50"
                  style={{ wordBreak: 'break-all' }}
                >
                  <code>/{userLinqProduct.alias.code}</code>
                </p>
              </td>
              <td style={{ verticalAlign: 'middle' }}>
                <Button
                  className="me-2"
                  onClick={() => setTransferProduct(userLinqProduct)}
                  variant="success"
                  size="sm"
                >
                  Transfer
                </Button>
                <Button
                  disabled={deleteUserLinqProductMutation.isLoading}
                  onClick={() =>
                    handleDeactivateProductClick(userLinqProduct.id)
                  }
                  variant="danger"
                  size="sm"
                >
                  Deactivate
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {transferProduct && (
        <TransferProductToUserModal
          show={!!transferProduct}
          product={transferProduct}
          oldUser={user}
          handleClose={() => setTransferProduct(null)}
          userUUID={userUUID}
        />
      )}
    </div>
  )
}
export default UserActivatedProductsTable
